import * as React from 'react'
import { flash$, FlashParams } from '../../../services/utils/flash.service'

export default function FlashComponent ({ content, type, fixed }: FlashParams) {
  React.useEffect(() => {
    flash$.next({ type, content, fixed })
  }, [content, fixed, type])
  
  return <></>
}
